import React from 'react';

export const pencilIcon = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 16.6676V20.0005H7.33287L17.1626 10.1708L13.8297 6.83789L4 16.6676ZM19.7396 7.59283C20.0862 7.24622 20.0862 6.68629 19.7396 6.33968L17.6599 4.25996C17.3133 3.91335 16.7533 3.91335 16.4067 4.25996L14.7803 5.8864L18.1131 9.21928L19.7396 7.59283ZM6 17L14 9L15 10L7 18L6 17Z"
            fill="#4B4D63"
        />
    </svg>
);
export const successIcon = (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="20" height="20" rx="10" fill="#4BE1A0" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.0573 6.19531L8.33333 11.8789L5.94267 9.50509L5 10.4404L8.33333 13.7509L15 7.13132L14.0573 6.19531Z"
            fill="#4B4D63"
        />
    </svg>
);

export const visaIcon = (
    <svg width="36" height="24" viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0 2.25C0 1.05 1.05 0 2.25 0H33.75C35.025 0 36 1.05 36 2.25V21.75C36 22.95 35.025 24 33.75 24H2.25C1.05 24 0 22.95 0 21.75V2.25Z"
            fill="#575DC1"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.8 15.6748H30.675L29.1 7.9498H27.45C26.7 7.9498 26.55 8.5498 26.55 8.5498L23.55 15.6748H25.65L26.1 14.5498H28.65L28.8 15.6748ZM26.55 12.9748L27.6 10.0498L28.2 12.9748H26.55ZM23.625 9.8248C22.8 9.3748 20.775 9.2248 20.775 10.1248C20.775 11.0248 23.55 11.1748 23.55 13.1998C23.55 15.1498 21.45 15.8248 20.1 15.8248C18.75 15.8248 17.85 15.3748 17.85 15.3748L18.15 13.6498C18.975 14.3248 21.45 14.4748 21.45 13.4248C21.45 12.3748 18.675 12.3748 18.675 10.3498C18.675 8.2498 21.075 7.7998 22.05 7.7998C22.95 7.7998 23.85 8.0998 23.85 8.0998L23.625 9.8248ZM16.65 15.6748H14.625L15.9 7.9498H17.925L16.65 15.6748ZM12.975 7.9498H15.15L11.925 15.6748H9.825L8.1 8.9248C6.975 8.3248 6 8.0998 6 8.0998V7.9498H9.15C10.05 7.9498 10.125 8.6248 10.125 8.6248L10.8 12.0748L11.025 13.1998L12.975 7.9498Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.8 12.1499L10.125 8.6999C10.125 8.6999 10.05 8.0249 9.15 8.0249H6V8.1749C6 8.1749 7.5 8.4749 9 9.6749C10.35 10.7249 10.8 12.1499 10.8 12.1499Z"
            fill="#EE9F3F"
        />
    </svg>
);
export const crossIcon = (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="20" height="20" rx="10" fill="#E02E46" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.3659 7.65294L12.4135 6.70056L10.0322 9.08189L7.6516 6.7013L6.69922 7.65369L9.0798 10.0343L6.69922 12.4148L7.6516 13.3672L10.0322 10.9866L12.4135 13.368L13.3659 12.4156L10.9846 10.0343L13.3659 7.65294Z"
            fill="white"
        />
    </svg>
);

export const alertIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <rect width="20" height="20" rx="10" fill="#E02E46" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 12H9V4.66669H11V12ZM11 15.3334H9V13.3334H11V15.3334Z"
            fill="white"
        />
    </svg>
);
